import { Injectable } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { List } from '@models/list';
import { CacheService, CacheState } from '@services/cache/cache.service';
import { CallcardFilterService } from '@services/callcard-filter/callcard-filter.service';
import { Security } from '@services/security/security.service';
import { Observable, Subject } from 'rxjs';

const STAMP_API_URL: string = 'api/Stamp';

@Injectable({
  providedIn: 'root'
})
export class CallcardService {
  /**
   * @deprecated please consider using CurrentCardService
   */
  readonly onCardDisplay = new Subject<CallCard>();

  private _lists: any = {};

  private readonly _cardChanged = new Subject<CallCard>();
  get onCardChange(): Observable<CallCard> {
    return this._cardChanged.asObservable();
  }

  constructor(private cache: CacheService, private security: Security, private callcardFilterService: CallcardFilterService) {
    this.cache.state.subscribe(state => this.onCacheStateChanged(state));
    this.cache.listenForChange(CallCard).subscribe(() => this.onCallCardChanged());
  }

  private onCacheStateChanged(state: CacheState) {
    if (state === CacheState.idle) {
      this._lists = {};
    }
  }

  private onCallCardChanged() {
    Object.keys(this._lists).forEach(name => this._lists[name].refresh());
  }

  getCardsList(id: string, type: typeof CallCard, init: (list: List<CallCard>) => void = () => {}): List<CallCard> {
    if (!this._lists[id]) {
      this._lists[id] = this.cache.getListOf<CallCard>(type);
      this.callcardFilterService.filters.forEach(callcardFilter => this._lists[id].addFilter(callcardFilter));
      init(this._lists[id]);
    }

    return this._lists[id];
  }
}
